var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #63666f;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4079",
    "data-name": "Group 4079",
    transform: "translate(5667 8760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3585",
    "data-name": "Group 3585",
    transform: "translate(-5664 -8760)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    className: "cls-1",
    d: "M12.883,2.206a.6.6,0,0,1-.6-.6A1.665,1.665,0,0,0,11.81.417h0A1.92,1.92,0,0,0,10.618,0,1.665,1.665,0,0,0,9.425.477a1.665,1.665,0,0,0-.477,1.192.6.6,0,0,1-.6.6H7.1V4.054h7.035V2.266H12.883Z",
    transform: "translate(-2.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    className: "cls-1",
    d: "M13.713,3.7H12.7V5.369A1.55,1.55,0,0,1,10.97,7.039H4.531A1.666,1.666,0,0,1,2.8,5.369V3.7H1.789A1.794,1.794,0,0,0,0,5.489V21.705a1.757,1.757,0,0,0,1.789,1.789H13.713A1.757,1.757,0,0,0,15.5,21.705V5.489A1.794,1.794,0,0,0,13.713,3.7ZM10.732,18.367H2.5a.537.537,0,1,1,0-1.073h8.228a.537.537,0,1,1,0,1.073ZM1.967,14.73a.534.534,0,0,1,.537-.537H8.287a.537.537,0,0,1,0,1.073H2.5A.534.534,0,0,1,1.967,14.73Zm8.764-2.564H2.5a.537.537,0,1,1,0-1.073h8.228a.537.537,0,1,1,0,1.073Z",
    transform: "translate(0 -1.494)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    className: "cls-2",
    width: 22,
    height: 22,
    transform: "translate(-5667 -8760)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.84c852b11d3e17d3e7c9adc50586df0c.svg";
export { ForwardRef as ReactComponent };